import Base from './base';

class Admin extends Base {
  getAdminBrokers = (payload) => {
    return this.apiClient.get('brokers', payload);
  };

  getAdminReps = (payload) => {
    return this.apiClient.get('reps', payload);
  };

  // TODO
  getAdminProposals = (payload) => {
    return this.apiClient.get('reps', payload);
  };

  getAdminIssuers = (payload) => {
    return this.apiClient.get('issuers', payload);
  };

  getAdminBrokerProposals = (payload) => {
    return this.apiClient.get('admin/proposals', payload);
  };

  createCustomToken = (payload) => {
    return this.apiClient.post('users/custom-token', payload);
  };
}

export default Admin;
